interface LegacyEventRedirectOptions {
  eventId?: string | null;
  isAuthenticated: boolean;
  search?: string;
  hash?: string;
}

export function getLegacyEventRedirectPath({
  eventId,
  isAuthenticated,
  search = '',
  hash = '',
}: LegacyEventRedirectOptions): string {
  if (!eventId) {
    return isAuthenticated ? '/live' : '/';
  }

  if (!isAuthenticated) {
    return `/e/${encodeURIComponent(eventId)}${search}${hash}`;
  }

  const params = new URLSearchParams(search);
  params.set('event', eventId);

  const query = params.toString();
  return `/live${query ? `?${query}` : ''}${hash}`;
}
